import React from "react";
import { BounceLoader } from "react-spinners";
import "../../assets/css/flashcardgame.css";
import "../../assets/css/in-game-settings.css";
import { SettingsIcon } from "./InGameSettingsModal";
import BackToDashboardButton from "./BackToDashboardButton";

function LoadingScreen({
    title = "Loading...",
    subtitle = null,
    onBack = null,
    backLabel = "Dashboard",
    onSettingsClick = null,
    settingsMenu = null,
    spinnerColor = "#3498db",
    inline = false,
    size = null,
    className = "",
    style = {}
}) {
    const isInline = inline;
    const hasTitle = Boolean(title);
    const TitleTag = isInline ? "h2" : "h1";

    const containerClasses = [
        "loading-screen-fflash",
        isInline ? "loading-screen-fflash--inline" : "",
        className
    ].filter(Boolean).join(" ");

    const centerClasses = [
        "loading-center-fflash",
        isInline ? "loading-center-fflash--inline" : "",
        isInline && !hasTitle ? "loading-center-fflash--compact" : ""
    ].filter(Boolean).join(" ");

    const titleClasses = [
        "loading-title-fflash",
        isInline ? "loading-title-fflash--inline" : ""
    ].filter(Boolean).join(" ");

    const spinnerSize = size !== null ? size : (isInline ? 40 : 60);

    return (
        <div className={containerClasses} style={style}>
            {onBack && (
                <BackToDashboardButton
                    floating
                    onClick={onBack}
                    label={backLabel}
                />
            )}
            {onSettingsClick && (
                <button
                    type="button"
                    aria-label="Settings"
                    className="in-game-settings-btn settings-btn-fflash"
                    onClick={onSettingsClick}
                >
                    <SettingsIcon size={28} />
                </button>
            )}
            {settingsMenu}
            <div className={centerClasses}>
                {hasTitle && <TitleTag className={titleClasses}>{title}</TitleTag>}
                {subtitle && (
                    <p style={{
                        color: "#6b7280",
                        marginTop: "-8px",
                        marginBottom: "16px",
                        fontSize: isInline ? "0.95rem" : "1.05rem",
                        textAlign: "center"
                    }}>
                        {subtitle}
                    </p>
                )}
                <div className="loading-spinner">
                    <BounceLoader color={spinnerColor} size={spinnerSize} />
                </div>
            </div>
        </div>
    );
}

export { LoadingScreen };
export default LoadingScreen;
